import ButtonBlue from '../../../components/ui/button/_color/_blue'

import styles from './styles.module.scss'
import Item1Icon from './icons/item_1-icon.svg'
import Item2Icon from './icons/item_2-icon.svg'
import Item3Icon from './icons/item_3-icon.svg'
import Item4Icon from './icons/item_4-icon.svg'
import { useTranslation } from 'utils/use-translation'

export default function HowUse({ handleGoToRefferal }) {
  const { t } = useTranslation()
  
  return (
    <div className={styles.wrapper}>
      <div className={styles.items}>
        <div className={styles.item}>
          <img className={styles.item__icon} src={Item1Icon} alt="item icon" />
          <p className={styles.item__text}>{t('email_dm')}</p>
        </div>

        <div className={styles.item}>
          <img className={styles.item__icon} src={Item2Icon} alt="item icon" />
          <p className={styles.item__text}>{t('post_on_website')}</p>
        </div>

        <div className={styles.item}>
          <img className={styles.item__icon} src={Item3Icon} alt="item icon" />
          <p className={styles.item__text}>{t('social_share')}</p>
        </div>

        <div className={styles.item}>
          <img className={styles.item__icon} src={Item4Icon} alt="item icon" />
          <p className={styles.item__text}>{t('video_review')}</p>
        </div>
      </div>
      <ButtonBlue bordered disableHoverColor className={styles.button} onClick={handleGoToRefferal}>{t('get_referral_link')}</ButtonBlue>
    </div>
  )
}
